
import LanguageSelector, { LanguageCode } from 'components/LanguageSelector';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useContentLanguage } from 'store';
import { ContentLanguageSelectorWrapper } from './ContentLanguageSelector.style';
import { useUserData } from 'hooks';
import userPreferencesAction from "redux/actions/userPreferencesAction";
import UserService from 'services/userServices';
import { UserPreferences } from 'models';

const ContentLanguageSelector: React.FC = () => {
  const [
    globalContentLanguage,
    // setGlobalContentLanguage,
  ] = useContentLanguage();

  const dispatch = useDispatch();
  const currentUser = useUserData();
  const userPreferences = useSelector(
    ({ userPreferencesReducer }: RootState) =>
      userPreferencesReducer.userPreferences as UserPreferences
  );

  const { generalConfig } = useSelector((state: RootState) => state.configReducer);
  const languageData = generalConfig?.supportLanguage;
  const otherLanguageKB = generalConfig?.KbConfig?.otherLanguageKB;
  const toTalLangActive = languageData?.data?.filter((item: any) => item.active);

  const saveUserLanguagePreference = async (language: LanguageCode) => {
    try {
      const response = await UserService.upsertPreferences({
        user_uid: currentUser?.uid,
        preferences: {
          language: language,
        },
      });
      if (response.status === 200) {
        userPreferences.preferences.language = language;
        dispatch(userPreferencesAction.updateUserPreferences(userPreferences.preferences));
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <ContentLanguageSelectorWrapper id="content-language-wrapper">
        <LanguageSelector
          toTalLangActive={toTalLangActive}
          languageCode={globalContentLanguage}
          otherLanguageKB={otherLanguageKB}
          onChange={language => {
            // setGlobalContentLanguage(language);
            saveUserLanguagePreference(language);
          }}
          kind="app-content"
        />
      </ContentLanguageSelectorWrapper>
    </>
  );
};

export default ContentLanguageSelector;
